import script from "./FlyerDropBoxView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FlyerDropBoxView.vue?vue&type=script&setup=true&lang=ts"

import "./FlyerDropBoxView.vue?vue&type=style&index=0&id=68f4f387&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68f4f387"]])

export default __exports__